'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var reverse = function reverse(promise) {
  return new Promise(function (resolve, reject) {
    return Promise.resolve(promise).then(reject, resolve);
  });
};

Promise.any = function (iterable) {
  return reverse(Promise.all([].concat(_toConsumableArray(iterable)).map(reverse)));
};

exports.default = Promise;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/cep-promise/dist/utils/promise-any.js
// module id = 710
// module chunks = 0